<template>
  <el-form :inline="true" :model="queryParams" class="-mb-15px">
    <el-form-item label="标签名称">
      <el-input
        v-model="queryParams.name"
        clearable
        placeholder="请输入标签名称"
        @keyup.enter="getList"
      />
    </el-form-item>
    <el-form-item label="启用状态">
      <el-select v-model="queryParams.status" clearable class="!w-160px">
        <el-option label="启用" :value="0" /><el-option label="关闭" :value="1" />
      </el-select>
    </el-form-item>
    <el-form-item>
      <el-button type="primary" @click="getList"><Icon icon="ep:search" />搜索</el-button>
      <el-button @click="resetQuery"><Icon icon="ep:refresh" />重置</el-button>
      <el-button
        type="primary"
        plain
        v-hasPermi="['activity:tag:create', 'activity:category:create']"
        @click="openForm()"
      >
        <Icon icon="ep:plus" />新增标签
      </el-button>
    </el-form-item>
  </el-form>
  <el-table v-loading="loading" :data="list" border>
    <el-table-column label="排序" prop="sort" width="90" />
    <el-table-column label="标签名称" prop="name" min-width="180">
      <template #default="scope"
        ><el-tag :style="getTagStyle(scope.row.color)" effect="plain">{{
          scope.row.name
        }}</el-tag></template
      >
    </el-table-column>
    <el-table-column label="颜色" prop="color" width="150" />
    <el-table-column label="状态" width="100">
      <template #default="scope"
        ><el-tag :type="scope.row.status === 0 ? 'success' : 'info'">{{
          scope.row.status === 0 ? '启用' : '关闭'
        }}</el-tag></template
      >
    </el-table-column>
    <el-table-column label="创建时间" prop="createTime" width="170" :formatter="dateFormatter" />
    <el-table-column label="操作" width="160" fixed="right">
      <template #default="scope">
        <el-button
          link
          type="primary"
          v-hasPermi="['activity:tag:update', 'activity:category:update']"
          @click="openForm(scope.row.id)"
          >编辑</el-button
        >
        <el-button
          link
          type="danger"
          v-hasPermi="['activity:tag:delete', 'activity:category:delete']"
          @click="handleDelete(scope.row.id)"
          >删除</el-button
        >
      </template>
    </el-table-column>
  </el-table>
  <Pagination
    v-model:page="queryParams.pageNo"
    v-model:limit="queryParams.pageSize"
    :total="total"
    @pagination="getList"
  />
  <Dialog v-model="visible" :title="form.id ? '编辑标签' : '新增标签'" width="480px">
    <el-form ref="formRef" :model="form" :rules="rules" label-width="90px">
      <el-form-item label="标签名称" prop="name"
        ><el-input v-model="form.name" maxlength="20" show-word-limit
      /></el-form-item>
      <el-form-item label="标签颜色"><el-color-picker v-model="form.color" /></el-form-item>
      <el-form-item label="启用状态"
        ><el-switch v-model="form.status" :active-value="0" :inactive-value="1"
      /></el-form-item>
      <el-form-item label="排序"><el-input-number v-model="form.sort" :min="0" /></el-form-item>
    </el-form>
    <template #footer
      ><el-button @click="visible = false">取消</el-button
      ><el-button type="primary" :loading="submitting" @click="submit">确定</el-button></template
    >
  </Dialog>
</template>

<script setup lang="ts">
import { dateFormatter } from '@/utils/formatTime'
import * as TagApi from '@/api/activity/tag'
const message = useMessage()
const loading = ref(false)
const submitting = ref(false)
const visible = ref(false)
const list = ref<any[]>([])
const total = ref(0)
const formRef = ref()
const queryParams = reactive({
  pageNo: 1,
  pageSize: 20,
  name: '',
  status: undefined as number | undefined
})
const form = reactive<TagApi.ActivityTagVO>({ name: '', color: '#409EFF', status: 0, sort: 0 })
const rules = { name: [{ required: true, message: '标签名称不能为空', trigger: 'blur' }] }
const getTagStyle = (color?: string) => {
  const value = /^#[0-9a-f]{6}$/i.test(color || '') ? color! : '#409EFF'
  return {
    color: value,
    borderColor: `${value}66`,
    backgroundColor: `${value}1A`
  }
}
const getList = async () => {
  loading.value = true
  try {
    const data = await TagApi.getTagPage(queryParams)
    list.value = data.list || []
    total.value = data.total || 0
  } finally {
    loading.value = false
  }
}
const resetQuery = () => {
  queryParams.name = ''
  queryParams.status = undefined
  queryParams.pageNo = 1
  getList()
}
const openForm = async (id?: number) => {
  Object.assign(form, { id: undefined, name: '', color: '#409EFF', status: 0, sort: 0 })
  if (id) Object.assign(form, await TagApi.getTag(id))
  visible.value = true
}
const submit = async () => {
  await formRef.value?.validate()
  submitting.value = true
  try {
    form.id ? await TagApi.updateTag(form) : await TagApi.createTag(form)
    message.success('保存成功')
    visible.value = false
    getList()
  } finally {
    submitting.value = false
  }
}
const handleDelete = async (id: number) => {
  await message.confirm('确定删除该标签？')
  await TagApi.deleteTag(id)
  message.success('删除成功')
  getList()
}
onMounted(getList)
</script>
